import type { RyftAccountPendingPayoutsListResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementPendingPayouts = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.RyftManagementPendingPayouts,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "ryft-management/accounts/payouts/pending",
      }).then(
        (response) =>
          apiV2AssertResponse<RyftAccountPendingPayoutsListResponseType>(
            response,
          ).data,
      ),
    ...getDefaultQueryOptionsV2<RyftAccountPendingPayoutsListResponseType>({
      context: { scope: "supplier", user, business },
    }),
  });
};
